<template>
  <div class="drag2" :hidden="!ifShow">
    <el-form :inline="true" :model="businessData" :rules="rules" ref="businessDataForm" label-width="100px">
      <el-row type="flex" justify="center">
        <el-form-item label="节点code" prop="code">
          <el-input v-model="businessData.nodeCode" style="width: 270px" disabled></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="center">
        <el-form-item label="节点名称" prop="name">
          <el-input v-model="businessData.nodeName" style="width: 270px" disabled></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="left">
          <el-tabs v-model="activeNodeName" type="card">
            <el-tab-pane label="输出参数配置" name="first">
              <el-row type="flex" justify="left">
                <el-button type="primary" class="el-icon-plus" @click="addEvaluation"/>
                <el-button type="primary" @click="saveEvaluation">保存</el-button>
              </el-row>
              <el-row type="flex" justify="center" style="margin-top: 5px" v-for="(item, i) in evaluations" :key="i">
                <el-select v-model="item.name" clearable placeholder="请选择" style="width: 35%">
                  <el-option v-for="(item, i) in variablesData" :key="i" :label="item.name" :value="item.name"></el-option>
                </el-select>
                <el-button>=</el-button>
                <!--<el-input v-model="item.viewData" placeholder="输出值" clearable style="width: 55%"></el-input>-->
                <tribute-mention :ref="`evaluation-${item.name}`" :value.sync="item.viewData" :sources="variableSources"></tribute-mention>
                <el-button icon="el-icon-delete" @click="removeEvaluation(item, i)" type="text" style="color: #F56C6C"/>
              </el-row>
            </el-tab-pane>
          </el-tabs>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import debounce from 'throttle-debounce/debounce'
import TributeMention from '@/components/mention/tributeMention.vue'
import {loadMentionSources} from '@/utils/common'

export default {
  props: {
    ifShow: Boolean,
    variablesData: Array,
    nodeData: Object
  },
  data () {
    return {
      regex: new RegExp(`(?<=@)[sme].[a-zA-Z\\d_.]+(?=\\s)`, 'g'),
      editable: false,
      evaluations: [],
      businessData: {
        strategyId: null,
        graphicNodeId: '',
        nodeCode: 'end',
        nodeName: '结束'
      },
      rules: {},
      showAddFlag: false,
      activeNodeName: 'first',
      variableSources: []
    }
  },
  watch: {
    async 'nodeData.business' (value) {
      if (!this.editable) {
        this.businessData = this.$utils.clone(value, true)
        this.variableSources = await loadMentionSources.doLoadAllSources(this.businessData.strategyId)
        this.loadEvaluations()
        this.editable = true
      }
    },
    variablesData: {
      deep: true,
      handler (value) {
        this.variables = this.$utils.clone(value, true)
      }
    }
  },
  methods: {
    addEvaluation () {
      this.evaluations.push({
        strategyId: this.businessData.strategyId,
        graphicNodeId: this.businessData.graphicNodeId,
        name: '',
        expression: '',
        viewData: ''
      })
    },
    async loadEvaluations () {
      try {
        let params = {
          strategyId: this.businessData.strategyId,
          graphicNodeId: this.businessData.graphicNodeId
        }
        let res = await this.$http.post(`/strategy-node-variable/list`, params)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.evaluations = res.data
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略节点变量失败')
      }
    },
    saveEvaluation: debounce(300, async function () {
      console.info('saveEvaluation:')
      // 请求后端服务
      try {
        this.handleStrategyVariable()
        let res = await this.$http.post(`/strategy-node-variable`, this.evaluations)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.loadEvaluations()
        this.businessData.evaluations = this.$utils.clone(this.evaluations, true)
        let node = this.$utils.clone(this.nodeData.node, true)
        let business = this.$utils.clone(this.businessData, true)
        this.$emit('saveNodesData', {node: node, business: business})
        this.$message.success('保存成功')
      } catch (ex) {
        console.info(ex)
        this.$message.error('保存失败')
      }
    }),
    handleStrategyVariable () {
      this.evaluations.forEach((item, i) => {
        item.sequence = i + 1
        item.expression = this.getExpression(item.viewData, item.name)
        item.strategyRefVariables = this.getStrategyRefVariables(`evaluation-${item.name}`, 2)
      })
      console.info('handleStrategyVariable', this.evaluations)
    },
    removeEvaluation: debounce(300, function (row, index) {
      this.$confirm('确认删除吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          if (!row.id) {
            this.loadEvaluations()
            this.$message.success('删除成功!')
            return
          }
          let res = await this.$http.delete(`/strategy-node-variable/${row.id}/${this.businessData.strategyId}`)
          if (res.code !== '200') {
            this.$message.error(res.message)
            return
          }
          this.loadEvaluations()
          this.$message.success('删除成功')
        } catch (ex) {
          console.info(ex)
          this.$message.error('删除失败')
        }
      }).catch(action => {
      })
    }),
    getExpression (viewData, variableName) {
      console.info('getExpression', viewData, variableName)
      let variable = this.variables.find(s => s.strategyId === this.businessData.strategyId && s.name === variableName &&
        s.dataType === 2)
      let result = variable ? viewData : (viewData.match(this.regex) || viewData.includes('$') ? viewData : `"${viewData}"`)
      let output = `{"s_${variableName}":${result}}`
      return this.convertToExpression(output)
    },
    convertToExpression (output) {
      console.info('convertToExpression:refId', output)
      if (output) {
        output = output.replace(/@[e]./g, '').replace(/@m./g, 'm_').replace(/@s./g, 's_')
          .replace(/[$]max/g, this.mvelConfig.actionOptions.max).replace(/[$]min/g, this.mvelConfig.actionOptions.min)
      }
      return output
    },
    getStrategyRefVariables (refId, refSource) {
      console.info('getStrategyRefVariables:refId', refId)
      let variables = []
      let mentionRef = this.$refs[refId][0]
      if (!mentionRef) {
        mentionRef = this.$refs[refId]
      }
      if (!mentionRef) {
        return variables
      }
      console.info('getStrategyRefVariables:refId', mentionRef)
      variables = mentionRef.targets.map(s => {
        return {
          refId: s.id,
          refVariableType: s.refType,
          name: s.name,
          strategyId: this.businessData.strategyId,
          refSource: refSource
        }
      })
      console.info('getStrategyRefVariables:targets:', variables)
      return variables
    }
  },
  components: {
    TributeMention
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/decisionTree/end-node-business.vue